// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Anton&display=swap'); */

/* Tokens*/

:root {
    /* Font */
    --uno-font-default: Lato, Poppins, sans-serif;
    --uno-font-code: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    --uno-font-container: var(--uno-font-default);

    /* Size */
    --uno-size-0: 0px;
    --uno-size-2: 2px;
    --uno-size-5: 5px;
    --uno-size-4: 4px;
    --uno-size-8: 8px;
    --uno-size-10: 10px;
    --uno-size-12: 12px;
    --uno-size-15: 15px;
    --uno-size-16: 16px;
    --uno-size-20: 20px;
    --uno-size-24: 24px;
    --uno-size-28: 28px;
    --uno-size-32: 32px;

    /* Radius */
    --uno-radius-0: var(--uno-size-0);
    --uno-radius-2: var(--uno-size-2);
    --uno-radius-4: var(--uno-size-4);
    --uno-radius-8: var(--uno-size-8);
    --uno-radius-12: var(--uno-size-12);
    --uno-radius-16: var(--uno-size-16);
    --uno-radius-20: var(--uno-size-20);
    --uno-radius-24: var(--uno-size-24);
    --uno-radius-28: var(--uno-size-28);
    --uno-radius-32: var(--uno-size-32);

    /* Color */
    --uno-color-primary: red;

    /* Box sizing */
    --uno-box-sizing-border-box: border-box;
    --uno-box-sizing-default: var(--uno-box-sizing-border-box);

    /* Text Decoration */
    --uno-text-decoration-none: none;
    --uno-text-decoration-wavy: underline wavy green;

    /* Anchors */
    --uno-anchor-decoration-default: var(--uno-text-decoration-none);

    /* Toolbar */
    --uno-toolbar-icon-padding: var(--uno-size-4);
    --uno-toolbar-icon-height: var(--uno-size-24);
    --uno-toolbar-icon-width: var(--uno-toolbar-icon-height);

    /** Palette */
    --uno-palette-margin: var(--uno-size-4);
}`, "",{"version":3,"sources":["webpack://./src/@uno/styles/tokens.css"],"names":[],"mappings":"AAEA,gFAAgF;;AAEhF,UAAU;;AAEV;IACI,SAAS;IACT,6CAA6C;IAC7C,mFAAmF;IACnF,6CAA6C;;IAE7C,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,WAAW;IACX,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;;IAEnC,UAAU;IACV,wBAAwB;;IAExB,eAAe;IACf,uCAAuC;IACvC,0DAA0D;;IAE1D,oBAAoB;IACpB,gCAAgC;IAChC,gDAAgD;;IAEhD,YAAY;IACZ,gEAAgE;;IAEhE,YAAY;IACZ,6CAA6C;IAC7C,6CAA6C;IAC7C,wDAAwD;;IAExD,aAAa;IACb,uCAAuC;AAC3C","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Lato');\n@import url('https://fonts.googleapis.com/css?family=Poppins');\n/* @import url('https://fonts.googleapis.com/css2?family=Anton&display=swap'); */\n\n/* Tokens*/\n\n:root {\n    /* Font */\n    --uno-font-default: Lato, Poppins, sans-serif;\n    --uno-font-code: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n    --uno-font-container: var(--uno-font-default);\n\n    /* Size */\n    --uno-size-0: 0px;\n    --uno-size-2: 2px;\n    --uno-size-5: 5px;\n    --uno-size-4: 4px;\n    --uno-size-8: 8px;\n    --uno-size-10: 10px;\n    --uno-size-12: 12px;\n    --uno-size-15: 15px;\n    --uno-size-16: 16px;\n    --uno-size-20: 20px;\n    --uno-size-24: 24px;\n    --uno-size-28: 28px;\n    --uno-size-32: 32px;\n\n    /* Radius */\n    --uno-radius-0: var(--uno-size-0);\n    --uno-radius-2: var(--uno-size-2);\n    --uno-radius-4: var(--uno-size-4);\n    --uno-radius-8: var(--uno-size-8);\n    --uno-radius-12: var(--uno-size-12);\n    --uno-radius-16: var(--uno-size-16);\n    --uno-radius-20: var(--uno-size-20);\n    --uno-radius-24: var(--uno-size-24);\n    --uno-radius-28: var(--uno-size-28);\n    --uno-radius-32: var(--uno-size-32);\n\n    /* Color */\n    --uno-color-primary: red;\n\n    /* Box sizing */\n    --uno-box-sizing-border-box: border-box;\n    --uno-box-sizing-default: var(--uno-box-sizing-border-box);\n\n    /* Text Decoration */\n    --uno-text-decoration-none: none;\n    --uno-text-decoration-wavy: underline wavy green;\n\n    /* Anchors */\n    --uno-anchor-decoration-default: var(--uno-text-decoration-none);\n\n    /* Toolbar */\n    --uno-toolbar-icon-padding: var(--uno-size-4);\n    --uno-toolbar-icon-height: var(--uno-size-24);\n    --uno-toolbar-icon-width: var(--uno-toolbar-icon-height);\n\n    /** Palette */\n    --uno-palette-margin: var(--uno-size-4);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
